import { useTranslation } from "react-i18next";

import type { DeskAmenity } from "@lib/infrastructure";
import { Icon } from "@atoms";
import { getDeskAmenityIcon } from "@utils";

// What the area's desks can be equipped with
export const AreaDeskAmenities = ({ deskAmenities }: { deskAmenities: DeskAmenity[] }) => {
  const { t } = useTranslation();

  if (deskAmenities.length === 0) return null;

  return (
    <section className="flex flex-col gap-4">
      <h3 className="text-[20px] font-semibold leading-[25px]">{t("deskAmenities:deskAmenity_other")}</h3>
      <p>{t("workplace:DeskAmenities")}</p>

      <ul className="flex flex-col gap-4">
        {deskAmenities.map(amenity => (
          <li
            key={amenity}
            className="flex items-center gap-2">
            <Icon
              icon={getDeskAmenityIcon(amenity)}
              weight="thin"
              size="24px"
            />
            {t("deskAmenities:deskAmenity", { context: amenity })}
          </li>
        ))}
      </ul>
    </section>
  );
};
